import { render, staticRenderFns } from "./drawerHeaderTabs.vue?vue&type=template&id=29092a13&scoped=true&"
import script from "./drawerHeaderTabs.vue?vue&type=script&lang=js&"
export * from "./drawerHeaderTabs.vue?vue&type=script&lang=js&"
import style0 from "./drawerHeaderTabs.vue?vue&type=style&index=0&id=29092a13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29092a13",
  null
  
)

export default component.exports